import { alpha, Box, BoxProps, styled } from '@mui/material';

import { doNotForwardTheseProps } from '@/styles';

export const ImageContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  position: 'relative',

  '.MuiAlert-root': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export const StyledImage = styled('img', {
  shouldForwardProp: doNotForwardTheseProps('isHidden'),
})<{ isHidden?: boolean }>(({ isHidden, theme }) => ({
  display: 'block',
  objectFit: 'scale-down',
  width: '100%',
  height: '100%',
  opacity: isHidden ? 0 : 1,
  transformOrigin: 'center',
  transition: theme.transitions.create(['transform']),
}));

export const ImageLoader = styled(Box)(() => ({
  position: 'absolute',
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
}));

export const FileThumbnailContainer = styled((props: BoxProps) => (
  <Box className="FileThumbnailContainer" {...props} />
))(({ theme, onClick }) => ({
  borderRadius: 16,
  border: `1px solid ${theme.palette.grey[200]}`,
  backgroundColor: theme.palette.grey[200],
  height: '100%',
  width: '100%',
  position: 'relative',
  overflowY: 'auto',
  cursor: onClick ? 'pointer' : 'default',

  '.MuiAlert-root': {
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
  },
}));

export const ImageThumbnailContainer = styled(FileThumbnailContainer)(() => ({
  overflow: 'hidden',
}));

export const WebViewContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',
}));

export const WebView = styled('iframe')(() => ({
  height: '100%',
  width: '100%',
  border: 'none',
  display: 'block',
}));

export const PDFContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(2),
  maxWidth: 1400,
  margin: '0 auto',

  '.react-pdf__Document': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),

    '.react-pdf__message': {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
    },
  },
}));

export const FileViewerContainer = styled(Box)(() => ({
  position: 'relative',
  height: '100%',
  width: '100%',
}));

export const FileFrameAction = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
  zIndex: 4,

  '.MuiIconButton-root': {
    backgroundColor: theme.palette.primaries[400],
    borderRadius: 12,
    opacity: 0.5,
    transition: theme.transitions.create(['opacity', 'background-color']),

    '.MuiSvgIcon-root': {
      fill: theme.palette.common.white,
    },

    ':hover': {
      backgroundColor: theme.palette.primaries[400],
      opacity: 1,

      '.MuiSvgIcon-root': {
        fill: theme.palette.common.white,
      },
    },
  },
}));

export const FileViewerAction = styled(FileFrameAction)(({ theme }) => ({
  position: 'fixed',
  right: theme.spacing(3),
  zIndex: theme.zIndex.modal + 1,

  '.MuiIconButton-root': {
    backgroundColor: theme.palette.background.paper,

    '.MuiSvgIcon-root': {
      fill: theme.palette.grey[700],
    },

    ':hover': {
      backgroundColor: theme.palette.background.paper,

      '.MuiSvgIcon-root': {
        fill: theme.palette.grey[700],
      },
    },
  },
}));

export const FileViewerBottomAction = styled(FileViewerAction)(({ theme }) => ({
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(2),
  borderRadius: theme.shape.borderRadius,
  right: 'unset',
  top: 'unset',
  left: '50%',
  bottom: theme.spacing(3),
  flexDirection: 'row',
  transform: 'translateX(-50%)',
  zIndex: theme.zIndex.modal + 2,
}));

export const Lightbox = styled(Box)(({ theme }) => ({
  backgroundColor: alpha('' + theme.palette.primaries[800], 0.95),
  height: '100vh',
  width: '100vw',
  position: 'fixed',
  left: 0,
  top: 0,
  overflowY: 'auto',
  zIndex: theme.zIndex.modal,

  '.PDFContainer': {
    padding: theme.spacing(8),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),

    '.react-pdf__Document': {
      gap: theme.spacing(4),
      padding: theme.spacing(4),
    },
  },
}));

export const ImageViewerContainer = styled(Box)(() => ({
  height: '100%',
  width: '100%',

  '.react-transform-wrapper': {
    height: '100%',
    width: '100%',
  },
}));

export const ViewerLoader = styled(Box)(() => ({
  height: '100%',
  width: '100%',
  position: 'absolute',
  left: 0,
  top: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1,
}));
